import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MarsMartHome.css';

const MarsMartHome = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "CLIENT",
      subtitle: "ORDER FRESH FOOD & GROCERIES",
      path: "/mart-client/login",
      image: "https://cdn-icons-png.flaticon.com/512/3703/3703259.png", // Customer icon
      color: "upto-60"
    },
    {
      title: "OWNER",
      subtitle: "MANAGE PRODUCTS & ANALYTICS",
      path: "/mart-owner/login",
      image: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png", // Admin icon
      color: "upto-60"
    },
    {
      title: "DELIVERY AGENT",
      subtitle: "EARN ON EVERY DELIVERY",
      path: "/delivery/agent",
      image: "https://cdn-icons-png.flaticon.com/512/2972/2972185.png", // Delivery icon
      color: "upto-50"
    }
  ];

  return (
    <div className="marsmart-landing">
      {/* Hero Section */}
      <div className="marsmart-hero">
        <h1 className="marsmart-title">MarsMart</h1>
        <p className="marsmart-caption">
          Order food & groceries. Discover <br /> 
          the fastest delivery on the Red Planet!
        </p>
        
        {/* Search Bar Simulation */}
       
      </div>

      {/* Cards Section */}
      <div className="marsmart-cards-container">
        {cards.map((card, index) => (
          <div 
            key={index} 
            className="mm-card" 
            onClick={() => navigate(card.path)}
          >
            <div className="mm-card-content">
              <h2 className="mm-card-title">{card.title}</h2>
              <p className="mm-card-subtitle">{card.subtitle}</p>
              <div className={`mm-badge ${card.color}`}>FASTEST SERVICE</div>
            </div>
            
            <div className="mm-card-footer">
              <img src={card.image} alt={card.title} className="mm-card-icon" />
              <div className="mm-arrow-btn">→</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarsMartHome;